<template>
  <div>
    <el-form ref="staffForm" :model="form"  label-width="100px" class="demo-ruleForm t_center"
             align="left">
    
      <template v-if="specType==1">
        <el-table
            :data="modelTypeListData"
            :span-method="objectSpanMethod"
            max-height="500"
            border
        >
          <el-table-column
              v-for="col in modelTypeListMain"
              :prop="col.specName"
              :label="col.specName"
              fixed="left"
              min-width="150"
              align="center">
          </el-table-column>
          <el-table-column
              fixed="left"
              min-width="150"
              align="center">
            <template slot="header" slot-scope="scope">
              <span>关联课程内容</span>
              <el-button class="button-new-tag" size="small"  style="margin-left: 0" @click="gl()">+统一关联</el-button>
            </template>
            <template slot-scope="{row,$index}">
              <el-tag
                  v-if="row.commodity"
                  :key="row.commodity.courseId"
                  closable
                  :disable-transitions="false"
                  @close="handleTagClose(row)">
                {{row.commodity.name}}
              </el-tag>
              <el-button v-if="!row.commodity" class="button-new-tag" size="small" @click="gl(row)"  style="margin-left: 5px">+关联课程</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="specType==0">
        <el-form-item label="关联课程:" prop="courseId">
          <el-input placeholder="请输入内容" v-model="changeCommodity.name">
            <template slot="append">
              <el-button type="primary" @click="selectCourse">选择课程</el-button>
            </template>
          </el-input>
        </el-form-item>
      </template>
      <el-form-item>
        注意：商品信息部分的课程目录内容同步于所关联课程的课程目录
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="prev">上一步</el-button>
        <el-button type="primary" @click="saveAndNext(3)">保存</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
        title="选择课程"
        :visible.sync="choseCommodity"
        :close-on-click-modal=false
    >
    
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" style="margin-bottom: 10px">
        <el-row >
          <el-col :span="5" class="cls-col">
            <el-form-item label="所属分类" prop="selectedOption">
              <el-cascader
                  expand-trigger="hover"
                  size="small"
                  clearable
                  :options="courseOptions"
                  v-model="searchData.selectedOption"
                  style="width: 100%"
                  :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item label="课程名称" prop="name">
              <el-input v-model="searchData.name" placeholder="课程名称" size="small" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="cls-col">
            <el-form-item style="margin-top: 30px">
              <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
    
      </el-form>
    
      <el-table
          :data="commodityData"
          ref="commodityList"
          @select="select"
          border>
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            prop="name"
            label="课程名称">
        </el-table-column>
        <el-table-column
            prop="orgName"
            label="机构"
        >
        </el-table-column>
        <el-table-column
            prop="ccName"
            label="课程分类"
            :formatter="f_categoryName"
        >
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          style="margin-top: 5px; float: right; margin-right: 10px">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectCommodity()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
 
</template>

<script>
  
  export default {
    name: 'step3',
    props: {
      commodityId: {
        type:String,
        default: ''
      }
    },
    data() {
      
      return {
        spanArr: [],
        specType: 0,
        selectedCourse: [],
        courseOptions: [],
        courseList: [],
        modelTypeListMain: [],
        similarCommodityTempList: [],
        combinedCommodityTempList: [],
        skuCombinedPriceVoTempList: [],
        modelTypeListDataMain: [],
        modelTypeListData: [],
        form: {
          courseId: ''
        },
        courseName: '',
        org: [],
        commodityData: [],
        searchData: {
          limit: 0,
          page: 1,
          name: '',
          ccId: '',
          categoryOne: '',
          categoryThree: '',
          categoryTwo: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          status: 2,
          orgCode: ''
        },
        choseCommodity: false,
        total: 0,
        currentPage: 1,
        pageSize:10,
        changeCommodity: {},
        selectedCommodity: {}
      };
    },
    methods: {
      selectCommodity() {
        if(this.specType == 1) {
          if(this.selectedCommodity.skuId) {
            this.$set(this.selectedCommodity, 'commodity', this.changeCommodity);
          } else {
            for(let data of this.modelTypeListData) {
              this.$set(data, 'commodity', this.changeCommodity);
            }
          }
        }
        if(this.specType == 0) {
        
        }
        this.choseCommodity = false;
      },
      handleTagClose(row) {
        this.$delete(row, 'commodity');
      },
      select(selection, row) {
        if (selection.length > 1) {
          let del_row = selection.shift();
          this.$refs.commodityList.toggleRowSelection(del_row, false);
        }
        this.changeCommodity = row;
      },
      gl(row) {
        this.choseCommodity = true;
        if(row) {
          this.selectedCommodity = row;
        } else {
          this.selectedCommodity = {};
        }
        this.search();
      },
      changeCourse(val) {
        if(val.length > 0) {
          let courseTypeId = val[val.length-1];
          this.searchCourse(courseTypeId);
        }
      },
      objectSpanMethod(item) {
        let row = item.row;
        let column = item.column;
        let field = column.property;
        let rowIndex = item.rowIndex;
        let columnIndex = item.columnIndex;
        if(this.spanArr[field]) {
          const _row = this.spanArr[field][rowIndex];
          return {
            rowspan: _row,
            colspan: 1
          };
        }

      },
      searchCourse(courseTypeId) {
        if (!courseTypeId) {
          return;
        }
        let params = {
          courseTypeId: courseTypeId
        };
        this.https.fetchPost('/course/getCourseByTypeId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let courseList = data.data.data;
            this.courseList = courseList;
            let flag = false;
            for (let index in courseList) {
              if (this.form.courseId == courseList[index].courseId) {
                this.courseName = courseList[index].name;
                flag = true;
              }
            }
            if (!flag) {
              this.form.courseId = '';
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      f_categoryName(row, column, cellValue, index) {
        let categoryName = '';
        if(row.categoryOneName) {
          categoryName += row.categoryOneName;
        }
        if(row.categoryTowName) {
          categoryName += '/'+row.categoryTowName;
        }
        if(row.categoryThreeName) {
          categoryName += '/'+row.categoryThreeName;
        }
        return categoryName;
      },
      searchCourseType() {
        let params = {
          orgCode: this.form.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data.childNodeLst;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },

      saveAndNext(val) {
        let url = '/commodityInfo/updateCourseIdByCommodityId';
        /*if (!this.form.courseId) {
          this.$message.error('请选择关联课程');
        }*/
       
       
        let params = {
          commodityId: this.commodityId
        };
        
        if(this.specType == 1) {
          let skuPriceVoList = [];
          
          for(let commodity of this.modelTypeListData) {
            if(!commodity.commodity) {
              this.$message({
                message: '请关联课程！',
                info: 'success'
              });
              return;
            }
            let sku = {};
            sku.skuId = commodity.skuId;
            sku.courseId = commodity.commodity.courseId;
            
            skuPriceVoList.push(sku);
          }
          params.skuPriceVoList = skuPriceVoList;
        }

        if(this.specType == 0) {
          params.courseId = this.changeCommodity.courseId;
          if(!this.changeCommodity.courseId) {
            this.$message({
              message: '请关联课程！',
              info: 'success'
            });
            return;
          }
        }

          this.https.fetchPost(url, params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.$router.push({path: 'commodity'});
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );

      },
      handleCurrentChange(val) {
        this.search(val);
      },
      search(val) {
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.limit = 10;
        let params = this.searchData;
        let selectedCourseType = this.searchData.selectedOption;
        params.categoryOne = '';
        params.categoryTwo = '';
        params.categoryThree = '';
        if (selectedCourseType && selectedCourseType.length > 0) {


          switch (selectedCourseType.length) {
            case 1:
              params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 2:
              params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 3:
              params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
              break;
          }
        }

        this.https.fetchPost('/course/getCourseByType',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      prev() {
        this.$emit('changeStep','prev','0');
      },

      selectCommodityDetail(commodityId){
        let params = {
          commodityId: commodityId
        };
        this.https.fetchPost('/commodityInfo/getByCommodityId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let form = data.data.data;
            this.searchData.orgCode = form.orgCode;
            this.searchCourseType();
            this.specType = form.specType;
            if(this.specType == 1) {
              this.modelTypeListDataMain = JSON.parse(JSON.stringify(form.skuPriceVoList));
              if(form.skuSpecVoList) {
                this.modelTypeListMain = form.skuSpecVoList;
              }
            }
            if(this.specType == 0) {
              this.$set(this.changeCommodity, 'name', form.courseNameStr);
              this.$set(this.changeCommodity, 'courseId', form.courseId);
            }
            
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeModelTypeListData() {
        this.modelTypeListData = [];
        if(this.modelTypeListMain.length == 0) {
          return;
        }
        for(const modelType of this.modelTypeListMain) {
          this.makeupTable(modelType.specOptionVoList, modelType.specName);
        }
        
        
        for(let m of this.modelTypeListData) {
          let newValFieldTemp = {};
          const fields =  Object.keys(m);
          for(let field of fields) {
            if(field.indexOf('rice') == -1) {
              newValFieldTemp[field] = m[field];
            }
          }
          let s = JSON.stringify(newValFieldTemp);
          for(let modelTypeListData of this.modelTypeListDataMain) {
            if(modelTypeListData.attributeName == s) {
              let commodity = {};
              if(modelTypeListData.courseId) {
                commodity.courseId = modelTypeListData.courseId;
                commodity.name = modelTypeListData.courseName;
                this.$set(m,'commodity', commodity);
              }
             
              this.$set(m,'skuId', modelTypeListData.skuId);
            }
          }
        }
        this.rowspan();
      },
      
      makeupTable(columns,fieldName) {
        let modelTypeListDataTemp = [];
        if(this.modelTypeListData.length == 0) {
          for(const column of columns) {
            const d = {
              preferentialPrice: '',
              price: ''
            };
            d[fieldName] = column.specOptionName;
            modelTypeListDataTemp.push(d);
          }
        } else {
          for(const data of this.modelTypeListData) {
            for(const column of columns) {
              const d = JSON.parse(JSON.stringify(data));
              d[fieldName] = column.specOptionName;
              modelTypeListDataTemp.push(d);
            }
          }
        }

        this.modelTypeListData = modelTypeListDataTemp;
      },
      rowspan() {
        this.spanArr = {a:1};
        this.position = {a:1};
        let that = this;
        this.modelTypeListData.forEach((item,index) => {

          const fields =  Object.keys(item);
          if(index === 0) {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1) {
                that.spanArr[field] = [1];
                that.position[field] = 0;
              }
            });

          } else {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1) {
                if(that.modelTypeListData[index][field] === that.modelTypeListData[index-1][field] ){
                  that.spanArr[field][this.position[field]] += 1;
                  that.spanArr[field].push(0);
                }else{
                  that.spanArr[field].push(1);
                  that.position[field] = index;
                }
              }
            });
          }

        });
      },
      changeOrg() {
      
      },
      searchCourseType() {
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data.childNodeLst;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      selectCourse() {
        this.choseCommodity = true;
        this.search();
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      }
    },
    watch: {
      modelTypeListMain: function(newVal, oldVal) {
        this.changeModelTypeListData();
      },
    },
    
    created: function() {
      this.selectCommodityDetail(this.commodityId);
    }
  };
</script>

<style scoped>
  /deep/.el-table__header-wrapper .el-checkbox {
    display: none
  }
</style>
